// Multivariate Dependencies
import React from 'react';
// Components
import { ContainerLegacy } from '../styles/Containers/ContainerLegacy';
import { TabLegacy } from '../Tab';
/**
 * TabBar to hold the tab switch buttons.
 *
 * @deprecated Do not use legacy components anymore.
 * @param {TabBarProp} props { tabs, activeTabId, setActiveTabId }
 *
 * @returns {React.ReactElement} - returns a tab bar with tab switches
 */
export var TabBar = function (_a) {
    var tabs = _a.tabs, activeTabId = _a.activeTabId, setActiveTabId = _a.setActiveTabId;
    return (React.createElement(ContainerLegacy, { "data-testid": 'tabBar', as: 'div', display: 'flex', flexDirection: 'row', alignItems: 'flex-end', flexWrap: 'wrap', width: '100%' }, tabs.map(function (_a) {
        var id = _a.id, icon = _a.icon, title = _a.title, showTab = _a.showTab;
        return showTab && (React.createElement(TabLegacy, { key: id, title: title, icon: icon, active: id === activeTabId, onClick: function () { return setActiveTabId(id); } }));
    })));
};
//# sourceMappingURL=TabBar.js.map